// Custom React hooks for Every Scale app
// Barrel exports for clean imports

export { useScaleAudio } from './useScaleAudio';
export { useConfig, useAudioConfig, useVisualConfig, useTypographyConfig } from './useConfig';
export { useNecklaceExpansion } from './useNecklaceExpansion';

// Future hooks can be added here:
// export { useScaleRendering } from './useScaleRendering';
// export { useIntervalHighlighting } from './useIntervalHighlighting';
// export { useFilters } from './useFilters';